<template>
    <footer class="landing-footer">
        <div class="container clearfix">
            <nav class="site-nav row d-md-flex">
                <div class="col d-none d-md-block">
                    <router-link class="site-nav-link site-nav-link-primary" :to="{ name: `${$i18n.locale}.ruyi` }">{{ $t('pages.ruyi.title') }}</router-link><br>
                    <a class="site-nav-link" :href="$t('links.company-value.url')">{{ $t('links.company-value.title') }}</a><br>
                    <a class="site-nav-link" :href="$t('links.talents.url')">{{ $t('links.talents.title') }}</a><br>
                    <a class="site-nav-link" :href="$t('links.social-responsibility.url')">{{ $t('links.social-responsibility.title') }}</a>
                </div>
                <div class="col d-none d-md-block">
                    <router-link class="site-nav-link site-nav-link-primary" :to="{ name: `${$i18n.locale}.technology` }">{{ $t('pages.technology.title') }}</router-link><br>
                    <a class="site-nav-link" :href="$t('links.rd.url')">{{ $t('links.rd.title') }}</a><br>
                    <a class="site-nav-link" :href="$t('links.intelligent-manufacturing.url')">{{ $t('links.intelligent-manufacturing.title') }}</a><br>
                    <a class="site-nav-link" :href="$t('links.global-presence.url')">{{ $t('links.global-presence.title') }}</a><br>
                    <a class="site-nav-link" :href="$t('links.vertical-integration.url')">{{ $t('links.vertical-integration.title') }}</a>
                </div>
                <div class="col d-none d-md-block">
                    <router-link class="site-nav-link site-nav-link-primary" :to="{ name: `${$i18n.locale}.fashion` }">{{ $t('pages.fashion.title') }}</router-link><br>
                    <router-link class="site-nav-link" :to="{ name: `${$i18n.locale}.fashion`, hash: '#ruyi-brand-network' }">{{ $t('pages.fashion.text-block-01.title') }}</router-link><br>
                    <router-link class="site-nav-link" :to="{ name: `${$i18n.locale}.fashion`, hash: '#smcp' }">SMCP</router-link><br>
                    <router-link class="site-nav-link" :to="{ name: `${$i18n.locale}.fashion`, hash: '#renown' }">RENOWN</router-link>
                </div>
                <div class="col">
                    <div class="d-none d-md-block">
                        <router-link class="site-nav-link site-nav-link-primary" :to="{ name: `${$i18n.locale}.sustainability` }">{{ $t('pages.sustainability.title') }}</router-link><br>
                        <router-link class="site-nav-link" :to="{ name: `${$i18n.locale}.sustainability`, hash: '#green-energy' }">{{ $t('pages.sustainability.text-block-01.title') }}</router-link><br>
                        <router-link class="site-nav-link" :to="{ name: `${$i18n.locale}.sustainability`, hash: '#powering-future' }">{{ $t('pages.sustainability.text-block-02.title') }}</router-link><br>
                        <br>
                        <button class="site-nav-link site-nav-link-primary" @click="showSitemapOverlay">{{ $t('pages.sitemap.title') }}</button><br>
                        <a class="site-nav-link site-nav-link-primary" :href="$t('links.ruyi-news.url')">{{ $t('links.ruyi-news.title') }}</a>
                    </div>
                    <a class="site-nav-link site-nav-link-primary" :href="$t('links.contact.url')">{{ $t('links.contact.title') }}</a>
                    <address class="ruyi-address d-md-none" v-html="$t('widgets.footer-address')"></address>
                </div>
            </nav>
            <div class="brand mb-md-4 mb-xl-5">
                <img class="ruyi-logo" src="~@/assets/images/logos/ruyi.svg">
                <span class="ruyi-group d-block mx-auto mx-md-0">{{ $t('common.ruyi-group2') }}</span>
            </div>
            <div class="follow-us">
                <a class="follow-us-link" href="javascript:void(0)" target="_blank">
                    <i class="iconfont icon-weibo"></i>
                </a>
                <a class="follow-us-link" href="javascript:void(0)">
                    <i class="iconfont icon-wechat"></i>
                </a>
            </div>
        </div>
    </footer>
</template>

<script>
    import { mapActions } from 'vuex'

    export default {
      methods: {
        ...mapActions([
          'showSitemapOverlay',
          'showWechatOverlay'
        ])
      }
    }
</script>

<style lang="scss">
    @import '~@/assets/styles/app';

    .landing-footer {
        background-color: $black;
        padding-top: px2rem(40px);
        padding-bottom: px2rem(40px);
        text-align: center;

        @include media-breakpoint-up(md) {
            text-align: left;
            padding-bottom: px2rem(80px);
        }

        @include media-breakpoint-up(xl) {
            padding-top: px2rem(80px);
            padding-bottom: px2rem(160px);
        }

        .container {
            display: flex;
            flex-direction: column;

            @include media-breakpoint-up(md) {
                display: block;
            }
        }

        .site-nav {
            margin-bottom: px2rem(40px);
            order: 2;

            @include media-breakpoint-up(md) {
                float: right;
                margin-bottom: 0;
                width: 85%;
            }

            &-link {
                color: $grey;

                &-primary {
                    color: $white;
                    font-size: px2rem(18px);
                    font-weight: bold;

                    @include media-breakpoint-up(md) {
                        font-size: inherit;
                    }
                }
            }

            > .col {
                @include media-breakpoint-up(md) {
                    border-left: 1px solid $grey;
                    padding-right: 0;
                }

                @include media-breakpoint-up(xl) {
                    padding-left: px2rem(30px);
                }
            }
        }

        .brand {
            color: $white;
            order: 3;

            @include media-breakpoint-up(md) {
                width: 15%;
            }

            .ruyi-logo {
                order: 3;
                margin-bottom: px2rem(15px);
                width: px2rem(120px);

                @include media-breakpoint-up(md) {
                    width: px2rem(80px);
                }
            }

            .ruyi-group {
                font-size: px2rem(15px);
                font-weight: bold;
                text-align: center;
                text-transform: uppercase;
                width: px2rem(120px);

                @include media-breakpoint-up(md) {
                    font-size: px2rem(12px);
                    width: px2rem(80px);
                }

                [lang="en"] & {
                    letter-spacing: 0.1em;

                    @include media-breakpoint-up(md) {
                        letter-spacing: 0;
                    }
                }
            }
        }

        .follow-us {
            color: $white;
            font-size: px2rem(30px);
            margin-bottom: px2rem(40px);
            order: 1;

            @include media-breakpoint-up(md) {
                font-size: px2rem(15px);
                text-align: center;
                width: px2rem(80px);
            }

            @include media-breakpoint-up(xl) {
                font-size: px2rem(18px);
                margin-bottom: px2rem(80px);
            }

            &-link {
                color: inherit;
                margin-right: px2rem(30px);

                &:last-child {
                    margin-right: 0;
                }

                @include media-breakpoint-up(md) {
                    margin-right: px2rem(15px);
                }

                @include media-breakpoint-up(xl) {
                    margin-right: px2rem(30px);
                }
            }
        }

        .ruyi-address {
            color: #7a7a7a;
            font-size: px2rem(15px);
            line-height: 2;
            margin-top: 1rem;
        }
    }
</style>


// WEBPACK FOOTER //
// LandingFooter.vue?5b89659a